import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { environment } from "public/environments/environment";

@Injectable({
  providedIn: 'root'
})
export class ComplaintsTicktsService {

  refreshList = new BehaviorSubject<boolean>(false);

  constructor(private http: HttpClient) { }

  getAll(params: any): any {
    return this.http.get(`${environment.apiUrl}/Ticket/FilterTicktes`, { params });
  }

  getTikcetLogs(id: number): any {
    return this.http.get(`${environment.apiUrl}/Ticket/GetTikcetLogs/${id}`);
  }
  getReportElementsForCase(id: number): any {
    return this.http.get(`${environment.apiUrl}/ReportTemplate/GetReportElementsForCase?ticketId=${id}`);
  }
  getDisplayCommentForWhoms(id: number): any {
    return this.http.get(`${environment.apiUrl}/Ticket/GetDisplayCommentForWhoms?ticketId=${id}`);
  }
  getAvailableActions(id: number): any {
    return this.http.get(`${environment.apiUrl}/Ticket/GetAvailableActions?complaintId=${id}`);
  }
  assginServiceProviderWithCommericalNumberToTicket(model: any): any {
    return this.http.post(`${environment.apiUrl}/Ticket/AssginServiceProviderWithCommericalNumberToTicket`, model);
  }
  getComments(params: any): any {
    return this.http.get(`${environment.apiUrl}/Ticket/GetComments`, { params });
  }
  removeComment(commentId: number): any {
    return this.http.get(`${environment.apiUrl}/Ticket/RemoveComment?commentId=${commentId}`);
  }
  addComment(model: any): any {
    return this.http.post(`${environment.apiUrl}/Ticket/AddComment`, model);
  }
  editComment(model: any): any {
    return this.http.put(`${environment.apiUrl}/Ticket/EditComment`, model);
  }

  ChangeComplaintStatus(model: any): any {
    return this.http.post(`${environment.apiUrl}/Ticket/ChangeComplaintStatus`, model);
  }

  getTicketStatusBasedOnCurrentUserType(): any {
    return this.http.get(`${environment.apiUrl}/Ticket/GetTicketStatusBasedOnCurrentUserType`);
  }

  getCloseReasons(ticketId: number): any {
    return this.http.get(`${environment.apiUrl}/Ticket/GetCloseReasons?ticketId=${ticketId}`);
  }

  getConsumerUserDetails(IdentityNumber: number): any {
    return this.http.get(`${environment.apiUrl}/Ticket/GetConsumerUserDetails?IdentityNumber=${IdentityNumber}`);
  }

  getGeneralAttachments(params: any): any {
    return this.http.get(`${environment.apiUrl}/Ticket/GetGeneralAttachments`, { params });
  }

  uploadAttachments(data: any, ticketId: number) {
    return this.http.post(`${environment.apiUrl}/Ticket/UploadAttachments?ticketId=${ticketId}`, data, {
      reportProgress: true,
      observe: 'events'
    });
  }

  removeAttachment(attachmentId: number): any {
    return this.http.delete(`${environment.apiUrl}/Ticket/RemoveAttachment?attachmentId=${attachmentId}`);
  }

  getInstitutionLookupByTicketId(ticketId: number): any {
    return this.http.get(`${environment.apiUrl}/Lookup/GetInstitutionLookupByTicketId?ticketId=${ticketId}`);
  }

}
